import Hero from "@/components/Hero";
import CourseListings from "@/components/CourseListings";
import WhyMHFA from "@/components/WhyMHFA";
import AboutLiz from "@/components/AboutLiz";
import Testimonials from "@/components/Testimonials";
import UpcomingDates from "@/components/UpcomingDates";
import Venues from "@/components/Venues";
import SupportPackages from "@/components/SupportPackages";
import AdditionalWorkshops from "@/components/AdditionalWorkshops";
import CtaBanner from "@/components/CtaBanner";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function Home() {
  const location = useLocation();

  // Handle scrolling to hash after route change (e.g. /#upcoming-courses from another page)
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      // Wait for content to mount
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }, [location]);

  return (
    <div data-testid="home-page">
      <Hero />
      <CourseListings />
      <WhyMHFA />
      <AboutLiz />
      <UpcomingDates />
      <Venues />
      <AdditionalWorkshops />
      <SupportPackages />
      <Testimonials />
      <CtaBanner />
    </div>
  );
}
